import Text from '../Common/NewText'
import Link from '@/components/Common/Link'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import { EntityNudgeInfo } from '@/components/Stocks/Widgets/types'

const RisingPatternWidget = ({
  nudge_info,
}: {
  nudge_info?: EntityNudgeInfo
}) => {
  const { logo, title, description, navlink } = nudge_info ?? {}

  const jsx = (
    <div className="bg-brand-tertiary-blue rounded-md p-2.5 md:p-4">
      {/* <Text
        appearance="overline"
        addClassName={classNames('text-brand-grey-base', { 'ml-14': logo })}
      >
        BULLISH • 1 min ago
      </Text> */}
      <div className="flex items-start gap-x-2 ">
        {logo && (
          <StencilCDNImage
            src={logo}
            width={44}
            height={44}
            className="rounded-full"
            alt={title}
          />
        )}
        <div>
          {title && <Text appearance="subtitle1">{title}</Text>}
          {description && (
            <Text appearance="caption" addClassName="text-brand-grey-dark">
              {description}
            </Text>
          )}
        </div>
      </div>
    </div>
  )

  return navlink ? <Link href={navlink}>{jsx}</Link> : jsx
}

export default RisingPatternWidget
